import React, { useEffect, useState, useCallback } from 'react';
//CarbonComponents
import {
  DataTable,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  SkeletonText,
  TableExpandRow
} from 'carbon-components-react';
import { Referrals } from 'types';
import { phoneNumberFormatter } from 'utilities/validation';
import { typicalWaitTimeFormatter } from 'utilities/formatters';
import CustomRow from './row';
import Utils from 'utilities/helper.util';

interface EnquiryDetailsReferrals extends Referrals {
  isSandboxTest: boolean;
  responses?: any;
  notices?: any;
  organisationId?: number;
}

interface Props {
  referrals: any[];
  isLoading?: boolean;
  handleResponseClick?: Function;
  isFullSet?: boolean;
  showResponsePreview?: boolean;
}

export const DataTableBasicMobileViewCommponent: React.FC<Props> = ({
  referrals,
  isLoading,
  handleResponseClick,
  isFullSet,
  showResponsePreview
}: any) => {
  const headers = [
    { key: 'icon', header: '' },
    { key: 'assetowner', header: '' },
    { key: 'referralId', header: '' },
    { key: 'contact', header: '' },
    { key: 'waittime', header: '' },
    { key: 'status', header: '' },
    { key: 'responses', header: '' },
    { key: 'notices', header: '' },
    { key: 'organisationId', header: '' }
  ];

  const myEnquiriesPage = window.location.pathname === '/enquiries';
  if (myEnquiriesPage) {
    showResponsePreview = true;
  }

  const [rows, setRows] = useState([]);

  const checkResponseExpiry = useCallback((responses: any) => {
    const dateLast90 = Utils.getDateBeforeDays(90);
    const responsesWithExpiry: Array<any> = [];
    if (responses?.length > 0) {
      responses.forEach((res: any) => {
        let isExpired = false;
        const responseCreatedData = res.createdAt;
        const dayJsDate = Utils.getNewDate(responseCreatedData);
        if (dayJsDate <= dateLast90) {
          isExpired = true;
        } else {
          isExpired = false;
        }
        const resObject = {
          ...res,
          expired: isExpired
        };
        responsesWithExpiry.push(resObject);
      });
    }
    return responsesWithExpiry;
  }, []);

  useEffect(() => {
    const entries = referrals
      ?.map((item: EnquiryDetailsReferrals) => {
        const {
          status,
          externalId,
          contactPhoneNumber,
          contactEmail,
          name,
          waittime,
          organisationType,
          responses,
          notices,
          organisationId
        } = item;
        const contactNumber =
          contactPhoneNumber !== null &&
          contactPhoneNumber &&
          phoneNumberFormatter({
            phoneNumber: contactPhoneNumber
          }).getNationalNumberFormat();
        const phone = contactNumber || 'Not available';
        const email = contactEmail || 'Not available';
        const contact =
          contactPhoneNumber && contactEmail ? { phone, email } : undefined;

        const responsesWithExpiry = checkResponseExpiry(responses);

        return {
          id: `enquiry_${externalId}`,
          icon: organisationType,
          contact: contact || 'Not available',
          assetowner: name,
          status: status,
          waittime: typicalWaitTimeFormatter(waittime),
          referralId: externalId,
          responses: responsesWithExpiry,
          notices,
          organisationId
        };
      })
      .sort((itemA: any, itemB: any) =>
        itemA.assetowner.localeCompare(itemB.assetowner)
      );
    setRows(entries);
  }, [referrals, isFullSet, checkResponseExpiry]);

  return (
    <DataTable size="normal" rows={rows} headers={headers || []}>
      {({
        rows,
        headers,
        getRowProps,
        getTableProps,
        getTableContainerProps
      }: any) => (
        <TableContainer
          className="table-expandable referrals-table"
          {...getTableContainerProps()}
        >
          <Table size="normal" {...getTableProps()}>
            <TableBody>
              {isLoading ? (
                <>
                  <TableExpandRow>
                    <TableCell>
                      <div className="skeleton-row">
                        <SkeletonText />
                      </div>
                      <div className="skeleton-row">
                        <SkeletonText />
                      </div>
                    </TableCell>
                  </TableExpandRow>
                </>
              ) : (
                rows.map((row: any, i: any) => {
                  return (
                    <CustomRow
                      key={row.id}
                      row={row}
                      index={i}
                      getRowProps={getRowProps}
                      headers={headers}
                      handleResponseClick={handleResponseClick}
                      showResponsePreview={showResponsePreview}
                    />
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DataTable>
  );
};

export default React.memo(DataTableBasicMobileViewCommponent);
